import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import {
    selectShowEditEventModal,
    selectClickedTimeBlock,
    selectDateForClickedTimeBlock,
    selectTracks,
    selectDayRange,
    selectJobpacks,
    selectJobpackNamesForAddEventList,
    selectJobpackKeys,
    selectResourceForClickedTimeblock,
    selectResourceNamesForAddEventList,
    selectResourceKeys,
    selectFocussedEvent,
    selectFocussedEventIndices
} from "../redux/selectors";
import { closeEditEventModal, editEvent, deleteEvent } from "../redux/actions";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { CirclePicker } from "react-color";
function getModalStyle() {
    return {
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
        overflow: "visible"
    };
}

const styles = theme => ({
    paper: {
        position: "absolute",
        width: theme.spacing.unit * 55,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit,
        overflow: "visible"
    },

    margin: {
        margin: theme.spacing.unit
    }
});

class AddEventModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            start: "",
            end: "",
            id: "",
            name: "",
            jobpack_key: "",
            resource_key: false,
            assigned_task_key: false,
            color: "#f44336"
        };
    }
    handleClose = () => {
        this.props.closeEditEventModal();
    };

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.show !== prevProps.show) {
            if (this.props.show === true) {
                this.setState({
                    ...this.state,
                    start: "",
                    end: "",
                    id: "",
                    name: "",
                    jobpack_key: "",
                    resource_key: false,
                    assigned_task_key: false
                });
            }
        }

        if (this.props.focussedEvent !== prevProps.focussedEvent) {
            this.setState({
                ...this.state,
                ...this.props.focussedEvent
            });
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.props.show}
                    onClose={this.handleClose}
                >
                    <Card style={getModalStyle()} className={classes.paper}>
                        <CardHeader title={"Edit Event"} />

                        <CardContent>
                            <FormControl className={classes.margin}>
                                <InputLabel htmlFor="input-with-icon-adornment">
                                    Name
                                </InputLabel>
                                <Input
                                    id="input-with-icon-adornment"
                                    value={this.state.name}
                                    onChange={e => {
                                        this.setState({
                                            ...this.state,
                                            name: e.target.value
                                        });
                                    }}
                                />
                            </FormControl>
                            <div style={{ marginTop: "10px" }}>
                                <CirclePicker
                                    color={this.state.color}
                                    width="400px"
                                    onChangeComplete={color =>
                                        this.setState({
                                            ...this.state,
                                            color: color.hex
                                        })
                                    }
                                />
                            </div>
                        </CardContent>
                        <CardActions
                            className={classes.actions}
                            disableActionSpacing
                        >
                            <Button
                                href="#text-buttons"
                                className={classes.button}
                                onClick={e => {
                                    const event = this.state;
                                    const start = this.props.dayRange.start;
                                    const parentTrackIndex = this.props
                                        .focussedEventIndices.parentTrackIndex;
                                    const childTrackIndex = this.props
                                        .focussedEventIndices.childTrackIndex;
                                    const eventIndex = this.props
                                        .focussedEventIndices.eventIndex;
                                    const tracks = this.props.tracks;

                                    this.props.editEvent(
                                        event,
                                        start,
                                        parentTrackIndex,
                                        childTrackIndex,
                                        eventIndex,
                                        tracks
                                    );

                                    this.props.closeEditEventModal();
                                }}
                            >
                                Edit
                            </Button>
                            <Button
                                href="#text-buttons"
                                className={classes.button}
                                onClick={e => {
                                    const parentTrackIndex = this.props
                                        .focussedEventIndices.parentTrackIndex;
                                    const childTrackIndex = this.props
                                        .focussedEventIndices.childTrackIndex;
                                    const eventIndex = this.props
                                        .focussedEventIndices.eventIndex;
                                    const tracks = this.props.tracks;
                                    const event = this.state;

                                    this.props.deleteEvent(
                                        event,
                                        parentTrackIndex,
                                        childTrackIndex,
                                        eventIndex,
                                        tracks
                                    );

                                    this.props.closeEditEventModal();
                                }}
                            >
                                Delete
                            </Button>
                        </CardActions>
                    </Card>
                </Modal>
            </div>
        );
    }
}

export default withStyles(styles)(
    connect(
        store => {
            return {
                show: selectShowEditEventModal(store),
                clickedTimeBlock: selectClickedTimeBlock(store),
                clickedTimeBlockDate: selectDateForClickedTimeBlock(store),
                tracks: selectTracks(store),
                dayRange: selectDayRange(store),
                jobpacks: selectJobpacks(store),
                jobpackNameList: selectJobpackNamesForAddEventList(store),
                jobpackKeys: selectJobpackKeys(store),
                resource: selectResourceForClickedTimeblock(store),
                resourceNameList: selectResourceNamesForAddEventList(store),
                resourceKeys: selectResourceKeys(store),
                focussedEvent: selectFocussedEvent(store),
                focussedEventIndices: selectFocussedEventIndices(store)
            };
        },
        { closeEditEventModal, editEvent, deleteEvent }
    )(AddEventModal)
);
